<template>
    <div style="display: flex; flex-direction: column;">
        <div style="display:flex; align-items: center; margin-top: 20px; position: relative; justify-content: space-between; padding-bottom: 11px;">
            <div v-if="!isBackBtnHidden" @click="() => { $GlobalStore.closeLastModal() }" style="display: flex; align-items: center;">
                <img :src="require('@/assets/images/mypage/ico-move.png')" style="width: 10px; transform: rotate(180deg);margin-left: 12px;">
                <span style="font-size:14px; font-weight:500; margin-left:5px; color:#210F03;">뒤로가기</span>
            </div>
            <div style="position: absolute; left: 50%; transform: translateX(-50%); font-weight: 700;">사커하우 고객지원</div>
            <div>&nbsp;</div>
        </div>
        <div style="flex: 1; background-color: #f5f5f5; overflow-y: scroll; padding:0px 40px;">
            <div style="text-align: center; margin-bottom:32px;">
                <div style="display: flex; justify-content: center; align-items: center; width: 119px; height: 119px; margin: 0 auto; margin-top: 80px; background-color: #fff; border-radius: 50%;">
                    <img style="width: 65px;" :src="require('@/assets/img/splash_logo.png')" alt="">
                </div>
                <div style="text-align: center; margin-top: 21px;">
                    <img style="width: 96px;" :src="require('@/assets/img/soccerhow_text.png')" alt="">
                </div>
                <div style="font-size: 14px;font-weight: 500;line-height: 24px; margin-top: 4px;">내가 알던 축구의 확장</div>
                <div style=" padding: 12px 0; background-color: #ebebeb; border-radius: 12px; margin: 0 auto; margin-top: 20px; ">
                    <div style="font-weight: 700;line-height: 24px;">사커하우 매니저에게 직접 문의해주세요</div>
                    <div style="font-size: 14px;font-weight: 500;line-height: 24px; color: #606060;">평균 10분 이내에 답변을 받을 수 있습니다.</div>
                </div>
            </div>

            <div v-if="last_chat_contents && last_chat_contents.idx" style="background-color: #ebebeb; border-radius: 12px; padding:12px 20px; ">
                <div style="font-weight:bold; font-size:14px; color:#210F03;">채팅</div>
                <div style="display:flex;margin-top:12px;">
                    <div>
                        <img :src="require('@/assets/img/chat_logo.png')" style="width:40px; height:40px; border-radius:50%; border:2px solid #D9D9D9;">
                    </div>
                    <div style="display:flex; flex:1; flex-direction: column; padding-left:5px; overflow: hidden;">
                        <div style="font-weight:bold; font-size:14px; color:#210F03; margin-top:3px;">{{last_chat_contents.nic_name ? last_chat_contents.nic_name : '&nbsp;'}}</div>
                        <div style="font-weight:500; font-size:12px; color:#808080; margin-top:8px;overflow:hidden;text-overflow: ellipsis; white-space: nowrap;">{{last_chat_contents.contents}}</div>
                    </div>
                    <div style="font-size:12px; font-weight:500; color:#606060; padding-top:3px;">{{$Util.getMDDHangulStr(last_chat_contents.insert_date)}}</div>
                </div>
            </div>
            <div v-else style="height:92px;"></div>

            <div style="margin-top:31px;">
                <div @click="showInquiryPopup" style="padding: 12px 0; text-align: center; color: var(--color-main); border-radius: 12px; background-color: #210f03; font-weight: 500; font-size: 14px; line-height: 24px;">문의하기</div>
                <div style="font-size: 14px;font-weight: 500;line-height: 24px; margin-top: 8px; text-align: center;">평일 10시~19시 사이에 문의하면 더 빨라요</div>
            </div>
        </div>
    </div>
</template>

<script>
import ResponseCode from "../../ResponseCode";
import WebPushManager from '../../modules/WebPushManager'

const WEB_PUSH_TOKEN = 'WEB_PUSH_TOKEN';
const WEB_PUSH_TOKEN_STATE = 'WEB_PUSH_TOKEN_STATE';

export default {
    name: 'SoccerhowCustomerSupport',
    props : {
        isBackBtnHidden : {
            type : Boolean,
            default : false
        }
    },
    data(){
        return {
            last_chat_contents : {},
        }
    },
    methods: {
        async showInquiryPopup() {
            if(this.$Util.isApp()){
                await this.$Util.showChatWithAdmin();
            } else {
                if(this.$hasOwnProperty(localStorage, WEB_PUSH_TOKEN)
                    && (this.$GlobalStore.isLogin() || localStorage.getItem(WEB_PUSH_TOKEN_STATE) === 'nologin')
                    && (!this.$GlobalStore.isLogin() || localStorage.getItem(WEB_PUSH_TOKEN_STATE) === 'login')
                ){
                    await this.$Util.showChatWithAdmin();
                }else{
                    const html = `<div style="color: #210F03; padding: 20px 0px 20px 0px; border-bottom:1px solid #EBEBEB; font-weight:bold; font-size:16px;">PUSH알림을 허용해주세요.</div><div style="padding:0px 14px; line-height: 20px; font-size:14px;"><br>브라우저 PUSH알림을 잠깐만 켜두시면<br>더 빠르고 원활하게 답변을 받을 수 있어요</div>`
                    this.$GlobalStore.showConfirm(html, this.showChatting, '확인', '취소하기', this.$GlobalStore.CONFIRM_TYPE.VERSION4, false, () => { })
                }
            }
        },
        async showChatting(){
            await this.checkPermssion();
            this.$Util.showChatWithAdmin();
        },
        async checkPermssion(){
            let [isSuccess, token] = await WebPushManager.requestPermission();
            if(isSuccess){
                const parameters = {};
                parameters.token = token;
                const res = await this.$Axios.post('/api/nologin/device/push/set', parameters);
                if(res.data.code === ResponseCode.SUCCESS){
                    localStorage.setItem(WEB_PUSH_TOKEN, token);
                    localStorage.setItem(WEB_PUSH_TOKEN_STATE, this.$GlobalStore.isLogin() ? 'login' : 'nologin');
                }else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }
        },
        async getLastChatWithAdmin(){
            const res = await this.$Axios.get('/api/chat/last/withadmin');
            this.last_chat_contents = res.data.last_chat_contents;
        },
    },
    created(){
        this.showInquiryPopup = this.$Once(this.showInquiryPopup);
        this.showChatWithAdmin = this.$Once(this.showChatWithAdmin);
        this.getLastChatWithAdmin();
    }
}
</script>

<style scoped></style>